import React from "react";
import { Grid, Box, TableContainer } from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import PanoramaIcon from "@material-ui/icons/Panorama";
import FolderIcon from "@material-ui/icons/Folder";
import { withStyles } from "@material-ui/styles";
import FileDetail from "../fileManager/fileDetail";
import { styles } from "../fileManager/styles";
import TableHeader from "../fileManager/tableHeader";
import TableFile from "../fileManager/tableFile";
import TableFolder from "../fileManager/tableFolder";
import FileAction from "../fileManager/fileAction";
import { connect } from "react-redux";
import ConfirmDialog from "../fileManager/dialog";
import Loading from "../loading";
import { getThumbnaiImage } from "../../utils/storage";
import Header from "../../partials/header";
import { translate } from "react-i18next";
import FileManager from "../fileManager";

class ServiceStorage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      isOpenModal: false,
      selectedFolder: {
        key: "",
        size: 0,
        download: null,
        createdAt: new Date(),
        url: null,
        relativeKey: "",
      },
    };
    this.createNewFolder = this.createNewFolder.bind(this);
    this.createNewFile = this.createNewFile.bind(this);
    this.fetchStorage = this.fetchStorage.bind(this);
    this.checkDuplicatedName = this.checkDuplicatedName.bind(this);
    this.remove = this.remove.bind(this);
  }
  async componentDidMount() {
    this.fetchStorage();
  }
  async fetchStorage() {
    this.loading.startLoading();
    await this.props.listFiles();
    this.loading.stopLoading();
  }
  selectFile(file) {
    this.setState({ selectedFile: file });
  }
  async createNewFolder(key) {
    const { serviceCode } = this.props;

    this.loading.startLoading();
    await this.props.uploadFolder({
      serviceCode,
      prefix: key,
    });
    await this.fetchStorage();
    this.loading.stopLoading();
  }

  async createNewFile(files, prefix) {
    const file = files[0];
    const { serviceCode } = this.props;
    this.loading.startLoading();
    await this.props.uploadFile({
      file,
      prefix,
      serviceCode,
    });
    await this.fetchStorage();
    this.loading.stopLoading();
  }
  async remove(file) {
    this.loading.startLoading();
    this.setState({ selectedFile: null });
    await this.props.removeFile(file.url);
    await this.fetchStorage();
    this.loading.stopLoading();
  }

  checkDuplicatedName({ name, path }) {
    const { list } = this.props;
    const result = list.some((item) => {
      return item.key === path + name;
    });
    return !result;
  }
  render() {
    const { list, t } = this.props;
    const { selectedFile, selectedFolder, isOpenModal } = this.state;
    const col = selectedFile ? 8 : 12;
    return (
      <Box component="div">
        <Grid container spacing={3}>
          <Grid item lg={col} md={col} sm="12">
            <FileManager
              files={list}
              title={t("storage_items")}
              canFilter={false}
              icons={{
                FolderOpen: <FolderOpenIcon />,
                Folder: <FolderIcon />,
                File: <PanoramaIcon />,
                Delete: <DeleteOutlineOutlinedIcon />,
              }}
              headerRenderer={TableHeader}
              actionRenderer={(props) => {
                return (
                  <Grid container justify="space-between" alignItems="center">
                    <Header
                      session={t("sidebar_manage")}
                      title={t("sidebar_storage")}
                      button={null}
                      actionButton={() => {}}
                    />
                    <FileAction
                      {...props}
                      onCreateFile={(files, prefix) => {
                        this.createNewFile(files, prefix);
                      }}
                      allowCreateFile={true}
                      allowCreateFolder={true}
                    />
                  </Grid>
                );
              }}
              fileRenderer={(props) => {
                return (
                  <TableFile
                    {...props}
                    thumbnail={getThumbnaiImage(props.url)}
                    rename={null}
                    refresh={() => {
                      return this.props.getAlbumForRole();
                    }}
                    checkDuplicatedName={this.checkDuplicatedName}
                  />
                );
              }}
              folderRenderer={(props) => {
                return <TableFolder {...props} />;
              }}
              detailRenderer={FileDetail}
              detailRendererProps={{
                file: selectedFile,
                folder: selectedFolder,
                isDisplay: false,
              }}
              onCreateFolder={(key) => {
                this.createNewFolder(key);
              }}
              onCreateFiles={(files, prefix) => {
                this.createNewFile(files, prefix);
              }}
              onSelectFile={(file) => {
                this.setState({ selectedFile: file });
              }}
              onSelectFolder={(folder) => {
                this.setState({
                  selectedFolder: folder,
                });
              }}
              onDeleteFile={(file) => {
                this.setState({
                  selectedFile: file,
                  isOpenModal: !isOpenModal,
                });
              }}
            />
          </Grid>
          {selectedFile && (
            <Grid
              className="file-detail-container"
              item
              lg={12 - col}
              md={12 - col}
              sm="12"
            >
              {selectedFile && (
                <FileDetail
                  file={selectedFile}
                  folder={selectedFolder}
                  close={() => {
                    this.setState({ selectedFile: null });
                  }}
                  isDisplay={true}
                />
              )}
            </Grid>
          )}
        </Grid>
        <Loading
          onRef={(id) => {
            this.loading = id;
          }}
        />
        <ConfirmDialog
          open={isOpenModal}
          handleClose={() => {
            this.setState({ isOpenModal: !isOpenModal });
          }}
          file={selectedFile}
          confirm={() => {
            this.remove(selectedFile);
          }}
        />
      </Box>
    );
  }
}
const mapState = (state) => ({
  list: state.storage.list,
  serviceCode: state.user.user.roleId.serviceCode,
});
const mapDispatch = (dispatch) => ({
  listFiles: dispatch.storage.listFiles,
  uploadFile: dispatch.storage.uploadFile,
  uploadFolder: dispatch.storage.uploadFolder,
  removeFile: dispatch.storage.removeFile,
});
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(ServiceStorage)));
